const dic = JSON.parse(localStorage.dic);
import { filterTime } from '@/api/filter';

const SETTLEMENT_STATUS_MAP = { '0': '待结算', '1': '已结算' };

export const config = {
  mixins: [],
  data() {
    return {
      columns: [],
      extraColumns: []
    };
  },
  methods: {
    getColumns() {
      this.columns = [
        {
          title: '结算日期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算报表名称',
          align: 'center',
          slot: 'reportName',
          minWidth: 220
        },
        {
          title: '结算状态',
          align: 'center',
          key: 'settlementStatus',
          minWidth: 100,
          render(h, params) {
            if (params.row.settlementStatus == 0) {
              return <Tag color="orange">待结算</Tag>;
            } else {
              return <Tag color="green">已结算</Tag>;
            }
          }
        },
        {
          title: '总人数',
          align: 'center',
          key: 'userNum',
          minWidth: 80
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 80
        },
        {
          title: '保费合计(美元)',
          align: 'center',
          key: 'feeSum',
          minWidth: 140,
          render(h, params) {
            let feeSum = params.row.feeSum;
            return <span>{feeSum || '-'}</span>;
          }
        },
        {
          title: '佣金合计(港币)',
          align: 'center',
          key: 'commissionSum',
          minWidth: 140,
          render(h, params) {
            let commissionSum = params.row.commissionSum;
            return <span>{commissionSum || '-'}</span>;
          }
        },
        {
          title: '销售佣金',
          align: 'center',
          key: 'salesCommission',
          minWidth: 120,
          render(h, params) {
            let salesCommission = params.row.salesCommission;
            return <span>{salesCommission || '-'}</span>;
          }
        },
        {
          title: '推荐奖',
          align: 'center',
          key: 'recommendBonus',
          minWidth: 120,
          render(h, params) {
            let recommendBonus = params.row.recommendBonus;
            return <span>{recommendBonus || '-'}</span>;
          }
        },
        {
          title: '辅导奖',
          align: 'center',
          key: 'tutorBonus',
          minWidth: 120,
          render(h, params) {
            let tutorBonus = params.row.tutorBonus;
            return <span>{tutorBonus || '-'}</span>;
          }
        },
        {
          title: '管理津贴',
          align: 'center',
          key: 'teamBonus',
          minWidth: 120,
          render(h, params) {
            let teamBonus = params.row.teamBonus;
            return <span>{teamBonus || '-'}</span>;
          }
        },
        {
          title: '育成奖',
          align: 'center',
          key: 'trainBonus',
          minWidth: 120,
          render(h, params) {
            let trainBonus = params.row.trainBonus;
            return <span>{trainBonus || '-'}</span>;
          }
        },
        {
          title: '年度个人Bonus',
          align: 'center',
          key: 'personalBonus',
          minWidth: 130,
          render(h, params) {
            let personalBonus = params.row.personalBonus;
            return <span>{personalBonus || '-'}</span>;
          }
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          minWidth: 120,
          fixed: 'right'
        }
      ];

      this.extraColumns = [
        {
          title: '结算日期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            return <span>{filterTime(params.row.settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算报表名称',
          align: 'center',
          minWidth: 220,
          slot: 'reportName',
        },
        {
          title: '结算状态',
          align: 'center',
          key: 'settlementStatus',
          minWidth: 100,
          render(h, params) {
            const status = params.row.settlementStatus;
            if (status === '0') return <Tag color="orange">{SETTLEMENT_STATUS_MAP[status]}</Tag>;
            if (status === '1') return <Tag color="green">{SETTLEMENT_STATUS_MAP[status]}</Tag>;
            return <span>-</span>;
          }
        },
        {
          title: '总人数',
          align: 'center',
          key: 'userNum',
          minWidth: 80
        },
        {
          title: '积分合计（港币）',
          align: 'center',
          key: 'commissionSum',
          minWidth: 140,
          render(h, params) {
            return <span>{params.row.commissionSum || '-'}</span>;
          }
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          minWidth: 120,
          fixed: 'right'
        }
      ];
    }
  }
};
